import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService {
  public screenWidth$: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  public get screenWidth() {
    return this.screenWidth$.getValue();
  }

  setScreenWidth(width: number) {
    this.screenWidth$.next(width);
  }
}
